const fetchApi = async (url, options) => {
  try {
    const response = await window.fetch(url, options);
    return await response.json();
  } catch (err) {
    console.error(`Header: error fetching initial data from ${url}: ${err}`);
    return {};
  }
};

const getInitialData = async () => {
  const stateUrl = '/header/api/state';
  const useNavigationService = window.headerUiUseNavigationService;
  const configUrl = `/header/api/config/${
    useNavigationService ? 'navigation' : 'categories'
  }`;

  const configFetch = fetchApi(configUrl);
  const stateFetch = fetchApi(stateUrl, {
    headers: { 'Cache-Control': 'no-cache' },
  });

  const [configResponse, stateResponse] = await Promise.all([
    configFetch,
    stateFetch,
  ]);

  return {
    ...configResponse,
    ...stateResponse,
  };
};

export default getInitialData;
